import React, { useState } from 'react';
import axios from 'axios';
import { API_PATH } from '../Constant/constants';
import BookAppointment from './BookAppointment';
import { getToken } from '../config/auth';
export default function BookAppointmentPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    email: '',
    phone: '',
    gender: '',
    appointment_date: '',
    department: '',
    comments: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
const appointmentForm = async (e) => {
  e.preventDefault();
  try {
    const token = getToken(); // or wherever your token is stored
    const response = await axios.post(`${API_PATH}/api/appointment-form`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log('Form Submitted Successfully:', response.data);
    // Optionally reset the form or show Swal alert
  } catch (error) {
    console.error('Error Submitting Form:', error.response || error.message);
  }
};
  

  return (
    <div className="container-fluid bg-success-subtle py-5">
      <div className="row rounded-5 shadow-lg bg-white py-5 px-5">
        <div className="row align-items-center g-5">
          {/* <div className="col-lg-6">
            <h5 className="text-success fw-semibold mb-3">Ayurvedic Excellence</h5>
            <h1 className="display-3 fw-bold mb-4">Revitalize Naturally</h1>
            <p className="lead text-muted mb-4">
              Experience the holistic magic of Ayurveda tailored uniquely for your wellness journey.
            </p>

            <div className="mb-4">
              <div className="d-flex align-items-center mb-3">
                <div className="me-3">
                  <i className="fa fa-spa fa-2x text-success"></i>
                </div>
                <div>
                  <h6 className="mb-0">Expert Ayurvedic Practitioners</h6>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="me-3">
                  <i className="fa fa-leaf fa-2x text-success"></i>
                </div>
                <div>
                  <h6 className="mb-0">Customized Herbal Treatments</h6>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <i className="fa fa-heartbeat fa-2x text-success"></i>
                </div>
                <div>
                  <h6 className="mb-0">Personalized Wellness Plans</h6>
                </div>
              </div>
            </div>

            <a href="#" className="btn btn-success btn-lg rounded-pill px-5 py-3 shadow">Explore More</a>
          </div> */}

          <div className="col-lg-12">
           
              <BookAppointment />
           
          </div>
        </div>
      </div>
    </div>
  );
}
